import React from 'react';
import { CheckIcon, SettingsIcon } from 'lucide-react';
import { Button } from './Button';
import { nextRuns, youKeep } from '../data/content';
import type { LandingActions } from '../types/actions';
export function ControlSection({
  onFormCta
}: Pick<LandingActions, 'onFormCta'>) {
  return <section id="agent-support" className="w-full bg-white" data-id="element-28" data-mp="38bbb59wib1fx">
      <div className="mx-auto max-w-content px-4 py-14 md:px-8 md:py-20" data-id="element-29" data-mp="388ot2gbzp3jg">
        <h2 className="max-w-3xl font-display text-[26px] font-semibold leading-[1.12] tracking-[-0.025em] text-ink md:text-[38px]" data-id="element-30" data-mp="8v4kcjljl7c3">
          Keep control of your business. Gain a stronger operating system.
        </h2>

        <div className="mt-9 grid gap-4 md:mt-12 md:grid-cols-2 md:gap-6" data-id="element-31" data-mp="3w2gq7mumhpp6">
          <div className="rounded-2xl border border-line bg-canvas p-6 md:p-8" data-id="element-32" data-mp="3r0rcfzg0mxxe">
            <h3 className="font-display text-[13px] font-semibold uppercase tracking-[0.14em] text-ink-400" data-id="element-33" data-mp="2km8il70c3o6n">
              You Keep Control Of
            </h3>
            <ul className="mt-5 space-y-3.5" data-id="element-34" data-mp="131z1bdmioriv">
              {youKeep.map(item => <li key={item} className="flex items-start gap-3 text-[16px] font-medium leading-snug text-ink" data-id="element-35" data-mp="1305tvw42y39t">
                  <CheckIcon className="mt-[3px] h-4 w-4 shrink-0 text-accent" aria-hidden="true" data-id="element-36" data-mp="u1amigpaun4x" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-2xl bg-ink p-6 text-white md:p-8" data-id="element-37" data-mp="kbhc3j0w8e29">
            <h3 className="font-display text-[13px] font-semibold uppercase tracking-[0.14em] text-white/50" data-id="element-38" data-mp="ka67jgzmj2a3">
              NEXT Helps You Run
            </h3>
            <ul className="mt-5 space-y-3.5" data-id="element-39" data-mp="bblvgyokjquu">
              {nextRuns.map(item => <li key={item} className="flex items-start gap-3 text-[16px] font-medium leading-snug text-white" data-id="element-40" data-mp="fbwb7325xvmw">
                  <SettingsIcon className="mt-[3px] h-4 w-4 shrink-0 text-accent" aria-hidden="true" data-id="element-41" data-mp="1do80dej9y3a" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mt-8 max-w-2xl text-[16px] leading-relaxed text-ink-600 md:text-[18px]" data-id="element-42" data-mp="281owizsk071w">
          You do not need to choose between independence and support. HomeSmart NEXT is built to give agents both.
        </p>

        <div className="mt-6" data-id="element-43" data-mp="1z8tmlss55n5s">
          <Button onClick={() => onFormCta('control_section')} fullWidth className="sm:w-auto" data-id="element-44" data-mp="1u9h57nk1h8al">
            Talk With NEXT About Your Business
          </Button>
        </div>
      </div>
    </section>;
}